import React from "react";
import { Container } from "react-bootstrap";
import SEO from "../SEO/SEO";
import './EnviosYDevoluciones.css'

const EnviosYDevoluciones = () => {
  return (
    <main className="legal-page">
      <SEO
        title="Informacion de atencion | Whisky And Co"
        description="Catalogo publico e informativo. Consultas por WhatsApp o en el local."
        canonicalPath="/envios-y-devoluciones"
      />

      <Container className="legal-shell">
        <section className="legal-hero">
          <span className="legal-kicker">Whisky&Co</span>
          <h1>Informacion de atencion</h1>
          <p>
            Este sitio presenta nuestro catalogo, nuestra identidad y los canales para conversar con el local. La atencion comercial se confirma siempre por contacto directo.
          </p>
        </section>

        <section className="legal-layout">
          <aside className="legal-summary">
            <span className="legal-summary-label">En pocas palabras</span>
            <ul>
              <li>Catalogo publico e informativo.</li>
              <li>Consultas por WhatsApp o en el local.</li>
              <li>Precios y disponibilidad sujetos a confirmacion.</li>
              <li>No se procesan compras online.</li>
            </ul>
          </aside>

          <div className="legal-content">
            <article className="legal-card">
              <span className="legal-card-number">01</span>
              <h2>Catalogo con criterio</h2>
              <p>
                En <strong>Whisky&Co</strong> usamos esta web para mostrar una seleccion de whiskys, categorias, promociones y productos destacados. Cada ficha funciona como punto de partida para conocer una etiqueta y pedir asesoramiento.
              </p>
              <p>
                La informacion puede actualizarse con el tiempo. Ante dudas sobre precio, disponibilidad o recomendacion, el canal valido es el contacto directo con el local.
              </p>
            </article>

            <article className="legal-card">
              <span className="legal-card-number">02</span>
              <h2>Consultas personalizadas</h2>
              <p>
                Desde el detalle de cada producto podes iniciar una consulta por WhatsApp con el nombre del whisky ya incluido. Tambien podes escribirnos por recomendaciones, regalos, estilos o visitas al local.
              </p>
              <div className="legal-highlight">
                WhatsApp: <strong>+54 351 529-5096</strong>
              </div>
            </article>

            <article className="legal-card">
              <span className="legal-card-number">03</span>
              <h2>Donde estamos</h2>
              <p>
                Nuestro punto de atencion se encuentra en <strong>Av. Recta Martinolli 8669, Cordoba, Argentina</strong>. La web acompana la experiencia del local: muestra que hacemos, donde estamos y como contactarnos.
              </p>
            </article>
          </div>
        </section>
      </Container>
    </main>
  );
};

export default EnviosYDevoluciones;
